import React from "react";
import LogComment from "./logComment";
const LogCommentContainer = (props) => {
  return <LogComment commentaries={props.commentaries} />;
};

export default LogCommentContainer;
